module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.co.uk/en_gb/company/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.co.uk/en_gb/company/legal-info.html",
	"footer.copyright": "&copy; 2017 GROHE Limited",
	"homepage.headline": "GROHE SmartControl Configurator",
	"homepage.introtext": "Just answer a few questions below to  configurate the GROHE SmartControl shower system that will fit your needs. ",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Go back to homepage",
	"configurator.button.seeResults": "See results",
	"question1.question": "For which area in your bathroom do you need a shower configuration?",
	"question1.option1.text": "For my shower area",
	"question1.option2.text": "For my bath tub including a bath spout",
	"question2.question": "What type of installation do you prefer? Exposed, Concealed  or a combination of both?",
	"question2.option1.text": "Exposed: easy & effortless solution for retrofitting in front of the wall",
	"question2.option2.text": "Combination: hidden piping inside the wall and a thermostat with tray in front of the wall",
	"question2.option3.text": "Concealed: clean minimalistic look with all technology hidden inside the wall",
	"question3.question": "How would you like to operate your shower?",
	"question3.option1.text": "With SmartControl operation and a thermostat",
	"question3.option2.text": "With conventional operation and a thermostat",
	"question3.option3.text": "With a single lever mixer",
	"question3.option4.text": "With a diverter system (keeping existing faucet)",
	"question4.question": "What do you want to control with your Shower?",
	"question4.option1.text": "Only a hand shower",
	"question4.option2.text": "A large head shower (150-250mm) and a hand shower",
	"question4.option3.text": "An extra-large head shower (250-400mm) and a hand shower",
	"question4.option4.text": "A large head shower (150-250mm), a hand shower and a bath filler",
	"question4.option5.text": "An extra-large head shower (250-400mm), a hand shower and a bath filler",
	"question5.question": "What shape do you prefer?",
	"question5.option1.text": "Square",
	"question5.option2.text": "Round",
	"question6.question": "What do you want to control with your new SmartControl?",
	"question6.option1.text": "A head shower with two sprays and a hand shower",
	"question6.option2.text": "A head shower with two sprays and a hand shower",
	"question6.option3.text": "A head shower, a hand shower and a bath filler",
	"question6.option4.text": "A head shower, two side showers and a hand shower",
	"question6.option5.text": "A head shower and a hand shower",
	"question6.option6.text": "A hand shower and a bath filler",
	"question6.option7.text": "Only a hand shower",
	"question6.option8.text": "Only a bath filler",
	"question7.question": "Choose your colour",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "White/Chrome",
	"question7.option3.text": "White/Chrome",
	"question8.question": "Would you like a thermostat with an integrated hand shower holder?",
	"question8.option1.text": "Yes, with integrated shower holder",
	"question8.option2.text": "No, I will buy a separate hand shower holder",
	"question9.question": "How do you want your handshower to be held?",
	"question9.option1.text": "By a shower rail with height-adjustable shower holder",
	"question9.option2.text": "By a minimalistic shower holder",
	"question10.question": "Would you like to mount your head shower on the wall or on the ceiling?",
	"question10.option1.text": "Wall mounted head shower",
	"question10.option2.text": "Ceiling mounted head shower",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "For the correct installation you will need as well:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Start new configuration",
	"results.product.number": "Product number: #{number}",
	"results.product.button.productInformation": "Product information",
	"results.product.button.dealerLocator": "Find a showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Find a showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.en_gb.json
// module id = 745
// module chunks = 0